import * as R from 'ramda'
import util from '@/libs/util'

export default {
  validate (val) {
    const isStringAndEmpty = R.both(R.is(String), R.isEmpty)
    val = isStringAndEmpty(val)
      ? null
      : R.is(String, val)
        ? parseInt(val)
        : val

    return R.either(
      R.isNil,
      (n) => R.is(Number)(n) && n >= 1 && n <= 99999 && util.isInt(n)
    )(val)
  }
}
